import { Component } from '@angular/core';

@Component({
  selector: 'app-about-main-page',
  templateUrl: './about-main-page.component.html',  
})
export class AboutMainPageComponent {

}
